import en from '../locales/en.json';
import es from '../locales/es.json';

export const languages = 
[
    { // English
        name: 'English',
        code: 'en',
        locale: en,
        flag: '🇬🇧',
    },
    { // Spanish
        name: 'Español',
        code: 'es',
        locale: es,
        flag: '🇪🇸',
    }
];

// Prepare each language for export
const i18nMessages = {};
languages.forEach((lang) => {
  i18nMessages[lang.code] = lang.locale;
});
export const messages = i18nMessages;